import {
    USER_LOGOUT_START,
    USER_LOGOUT_SUCCESS,
    USER_LOGOUT_ERROR,
    SET_RUNTIME_VARIABLE
} from '../../constants';
import { userLogout as mutation } from '../../lib/graphql';
import { removeCookies } from '../../helpers/Cookies/cookies';
import history from '../../history';
import { closeHeaderModal } from '../siteadmin/modalActions';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';

export const userLogout = () => {
    return async (dispatch, getState, { client }) => {
        try {

            dispatch({
                type: USER_LOGOUT_START
            });
            dispatch(setLoaderStart('userLogoutLoading'))
            let userType = 1;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    userType
                },
            });
            if (data?.userLogout?.status === 200) {
                removeCookies({name:"id_token"})
                history.push('/');
                dispatch({
                    type: USER_LOGOUT_SUCCESS
                });
                dispatch({
                    type: SET_RUNTIME_VARIABLE,
                    payload: {
                        name: 'isAuthenticated',
                        value: false
                    }
                });
                dispatch(setLoaderComplete('userLogoutLoading'))
                return true;
            } else {
                dispatch({
                    type: USER_LOGOUT_ERROR
                });
                dispatch(setLoaderComplete('userLogoutLoading'))
                return false;
            }
        } catch (error) {
            dispatch({
                type: USER_LOGOUT_ERROR,
                payload: {
                    error
                }
            });
            dispatch(setLoaderComplete('userLogoutLoading'))
            return false;
        }
        return true;
    }
}